import { render } from "./CoachRegister.vue?vue&type=template&id=21e53a0c&scoped=true"
import script from "./CoachRegister.vue?vue&type=script&lang=js"
export * from "./CoachRegister.vue?vue&type=script&lang=js"

import "./CoachRegister.vue?vue&type=style&index=0&id=21e53a0c&scoped=true&lang=css"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e53a0c"]])

export default __exports__